module.exports = __webpack_public_path__ + "img/gear.f8929f39.svg";